// extracted by mini-css-extract-plugin
export default {"WorkerCardWrapper":"WorkerCard_WorkerCardWrapper__EFnfk","avatar":"WorkerCard_avatar__3jKgY"};